import React from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { camelize } from 'helpers/syntaxHelper';
import { styled } from '@mui/material';
import { translateBlock } from 'i18n';
import { useManageChartTemplateContext } from '../../ManageChartTemplateContext/ManageChartTemplateContext';
import { useTranslation } from 'react-i18next';

const ROOT_CHART_RECAP_PREFIX =
    'support.chartsTemplates.createOrEditModal.rootChartRecap';

const StyRootChartRecapContainer = styled('div')(({ theme }) => ({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

const StyTextField = styled(TextField)(({ theme }) => ({
    flexGrow: 1,
    '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.paper,
    },
}));

const TextFieldWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
});

type RootChartRecapProps = {
    rootUrlActionsButtons: React.ReactNode;
};
const RootChartRecap = ({ rootUrlActionsButtons }: RootChartRecapProps) => {
    const { t } = useTranslation();

    const {
        state: { metrics, dimensions, filters, rootUrl, vizType },
    } = useManageChartTemplateContext();

    const getChartDataParameters = [
        {
            type: 'metrics',
            value: metrics,
        },
        {
            type: 'dimensions',
            value: dimensions,
        },
        {
            type: 'filters',
            value: filters,
        },
    ];

    return (
        <>
            <StyRootChartRecapContainer>
                <Typography variant="body1SemiBold">
                    {t(`${ROOT_CHART_RECAP_PREFIX}.title`)}
                </Typography>
                <TextFieldWrapper>
                    <StyTextField
                        fullWidth
                        value={rootUrl}
                        disabled
                        variant="outlined"
                    />
                    {rootUrlActionsButtons}
                </TextFieldWrapper>
                <Typography variant="body1SemiBold">
                    {t(`${ROOT_CHART_RECAP_PREFIX}.vizType`)}
                </Typography>
                <Typography variant="body1">
                    {t(`settings.${vizType}`)}
                </Typography>
                {getChartDataParameters.map((param) => (
                    <>
                        <Typography variant="body1SemiBold">
                            {t(`${ROOT_CHART_RECAP_PREFIX}.${param.type}`)}
                        </Typography>
                        <Typography variant="body1">
                            {param.value
                                .map((exploreElement) =>
                                    translateBlock(
                                        camelize(exploreElement.field),
                                    ),
                                )
                                .join(', ')}
                        </Typography>
                    </>
                ))}
            </StyRootChartRecapContainer>
        </>
    );
};

export default RootChartRecap;
